import React from 'react';
import {useEffect, useState} from 'react'
import {
  SDrawerOrModal, SGeneralForms, STitle,
} from 'shj-components'
import {
  getBizOpTypeEnum,
  getProductionTypeEnum,
  getSignBillIntentEnum,
  trackPlanUpdate, trackPlanAdd,
} from "@/services/customerServices.ts";
import {Form, Input, Select, message} from 'antd';
import dayjs from 'dayjs';
import {isEmpty} from "lodash-es";
import {getEnums} from "@/services/homeService.ts";
import styles from "@/components/AllowcateWorkerModal/index.module.less";

export default function AddOrEditTrack({
                                          basicInfo = {},
                                          isEdit = false,
                                          open = false,
                                          onClose = () => {
                                          },
                                          reload = () => {
                                          },
                                          editReload = () => {
                                          },
                                        }) {
  const [form] = Form.useForm();
  const [dictionaryData, setDictionaryData] = useState({});
  const [buttonLoading, setButtonLoading] = useState(false);
  const [editId, setEditId] = useState('');

  useEffect(() => {
    fetchDictionaryData();
  }, []);

  useEffect(() => {
    if (isEdit) {
      console.log(basicInfo)
     if(!isEmpty(basicInfo)){
       setEditId((basicInfo as any)?.id);
       const info = {
         ...basicInfo,
         expectRenovationDate: basicInfo.expectRenovationDate ? dayjs(basicInfo.expectRenovationDate) : null,
         expectSignTime: basicInfo.expectSignTime ? dayjs(basicInfo.expectSignTime) : null,
         painPoint: basicInfo?.painPoint ? basicInfo?.painPoint.split('-') : null,
         itchPoint: basicInfo?.itchPoint ? basicInfo?.itchPoint?.split('-') : null,
         breakPoint: basicInfo?.breakPoint ? basicInfo?.breakPoint?.split('-') : null,
         blockPoint: basicInfo?.blockPoint ? basicInfo?.blockPoint?.split('-') : null,
       }
       form.setFieldsValue(info);
     }
    } else {
      setEditId('');
    }
  }, [isEdit])

  const formatOriginData = (data: any) => {
    if (data.children) {
      data.disabled = true;
      data.children.forEach(child => formatOriginData(child));
    }
  }
  const fetchDictionaryData = async () => {
    try {
      setButtonLoading(true)
      const resList: any = await Promise.allSettled([
        getBizOpTypeEnum(),
        getProductionTypeEnum(),
        getSignBillIntentEnum(),
        getEnums("plus-crm","com.shj.saas.plus.crm.enums.clue.PainPoint" ),
        getEnums("plus-crm","com.shj.saas.plus.crm.enums.clue.ItchPoint" ),
        getEnums("plus-crm","com.shj.saas.plus.crm.enums.clue.BreakPoint"),
        getEnums("plus-crm","com.shj.saas.plus.crm.enums.clue.BlockPoint"),
      ]);
      const map = {
        bizType: resList?.[0]?.value instanceof Array ? resList?.[0]?.value : [],
        intentionProductCode: resList?.[1]?.value instanceof Array ? resList?.[1]?.value : [],
        signIntentionCode: resList?.[2]?.value instanceof Array ? resList?.[2]?.value : [],
        painPoint: resList?.[3]?.value instanceof Array ? resList?.[3]?.value : [],
        itchPoint: resList?.[4]?.value instanceof Array ? resList?.[4]?.value : [],
        breakPoint: resList?.[5]?.value instanceof Array ? resList?.[5]?.value : [],
        blockPoint: resList?.[6]?.value instanceof Array ? resList?.[6]?.value : [],
      }
      setDictionaryData(map);
    } catch (err) {
      console.log(err)
    } finally {
      setButtonLoading(false)
    }
  }

  const onSubmit = () => {
    form.validateFields().then(async (values: any) => {
      setButtonLoading(true);
      const apiFn = isEdit ? trackPlanUpdate : trackPlanAdd;
      const _values = {
        ...values,
        id: values.id || basicInfo.id,
        painPoint: values.painPoint?.join('-'),
        itchPoint: values.itchPoint?.join('-'),
        breakPoint: values.breakPoint?.join('-'),
        blockPoint: values.blockPoint?.join('-'),
      }
      apiFn(_values).then(res => {
        message.success(res.message || '操作成功');
        onClose();
        reload();
      }).finally(() => {
        setButtonLoading(false);
      })
    })
  }

  return (
      <div>
        <SDrawerOrModal
            mode="drawer"
            open={open}
            loading={buttonLoading}
            onCancel={() => onClose()}
            onOk={onSubmit}
            width="900"
            style={{minWidth: 500}}
            title={isEdit ? "编辑商机" : "新增商机"}
        >
          <div className={styles.drawerFormBox}>
          <SGeneralForms
              layout={'vertical'}
              titleMode={'edit'}
              formConfig={{form}}
              configs={[
                {
                  formItem: [
                    {
                      spanCol: 12,
                      label: '需求标签',
                      name: 'bizType',
                      children: <Select placeholder={'请选择需求标签'}
                                        // mode={'multiple'}
                          disabled={true}
                                        fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['bizType']}/>
                    },
                    {
                      spanCol: 12,
                      label: '产品意向',
                      name: 'productIntention',
                      children:  <Select placeholder={'请选择产品意向'} fieldNames={{label: 'description', value: 'key'}}
                                         options={dictionaryData['intentionProductCode']}/>
                    },
                    {
                      spanCol: 12,
                      label: '签单意向',
                      name: 'signIntentionCode',
                      children: <Select placeholder={'请选择签单意向'} fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['signIntentionCode']}/>
                    },
                    {
                      spanCol: 12,
                      label: '预计签单时间',
                      name: 'expectSignTime',
                      type: 'dateTime',
                      comConfig: {
                      }
                    },
                    {
                      spanCol: 12,
                      label: '预计签单金额',
                      name: 'expectSignAmount',

                    },
                    {
                      spanCol: 12,
                      label: '预计进场装修时间',
                      name: 'expectRenovationDate',
                      type: 'date',
                      comConfig: {
                      }
                    },
                    {
                      spanCol: 12,
                      label: '痛点',
                      name: 'painPoint',
                      children: <Select mode={"multiple"} placeholder={'请选择痛点'} fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['painPoint']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '痛点备注',
                      name: 'painPointRemark',
                      isDeps: true,
                      deps: (form) => form.getFieldValue('painPoint')?.includes('PainPointOther'),
                      comConfig: {
                        maxLength: 200,
                        showCount: true
                      }
                    },
                    {
                      spanCol: 12,
                      label: '痒点',
                      name: 'itchPoint',
                      children: <Select mode={"multiple"} placeholder={'请选择痒点'} fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['itchPoint']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '痒点备注',
                      name: 'itchPointRemark',
                      isDeps: true,
                      deps: (form) => form.getFieldValue('itchPoint')?.includes('ItchyOther'),
                      comConfig: {
                        maxLength: 200,
                        showCount: true
                      }
                    },
                    {
                      spanCol: 12,
                      label: '障碍点',
                      name: 'blockPoint',
                      children: <Select mode={"multiple"} placeholder={'请选择障碍点'} fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['blockPoint']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '障碍点备注',
                      name: 'blockPointRemark',
                      isDeps: true,
                      deps: (form) => form.getFieldValue('blockPoint')?.includes('ObstaclePointOther'),
                      comConfig: {
                        maxLength: 200,
                        showCount: true
                      }
                    },
                    {
                      spanCol: 12,
                      label: '爆破点',
                      name: 'breakPoint',
                      children: <Select mode={"multiple"} placeholder={'请选择爆破点'} fieldNames={{label: 'description', value: 'key'}}
                                        options={dictionaryData['breakPoint']} allowClear showSearch optionFilterProp={'description'}/>
                    },
                    {
                      spanCol: 12,
                      label: '爆破点备注',
                      name: 'breakPointRemark',
                      isDeps: true,
                      deps: (form) => form.getFieldValue('breakPoint')?.includes('BlastingPointOther'),
                      comConfig: {
                        maxLength: 200,
                        showCount: true
                      }
                    },
                    {
                      spanCol: 24,
                      label: '备注',
                      name: 'remark',
                      comConfig: {
                       maxLength: 200,
                      }
                    },
                  ]
                }
              ]}/>
          </div>
        </SDrawerOrModal>
      </div>
  )
}